/** View library */
import React, { useCallback } from "react";
import Autobind from "autobind-decorator";
import { inject, observer } from "mobx-react";
/** Presentation Component */
import HeaderSection from "component/orgaisms/headerSection";
import HorizontalSpliiter from "component/atoms/horizontalSplitter";
import GridViewportSection from "component/orgaisms/gridViewportSection";
import ControlSection from "component/orgaisms/controlSection";
import FooterSection from "component/orgaisms/footerSection";
import DialogSection from "component/orgaisms/dialogSection/index.ts";

import LoadingSnackbar from "component/atoms/loadingSnackbar";
import LoadingSnackbarManager from "component/atoms/loadingSnackbar/loadingSnackbarManager";
import { Redirect, BrowserRouter as Router } from "react-router-dom";

import Provider from "core/provider/";

/** ETC, Utilities */
import Dropzone from "react-dropzone";
import { HotKeys } from "react-hotkeys"; // Hot key library
import HotKeyMap from "core/hotKeyMap"; // hotkey definition
import classNames from "classnames";
import Constant from "constants/index";

/** Resources */
import BrandImage from "assets/brand/logo.png";
import Icon from "assets/icon";

/** Stylus */
import "./SarcopeniaDemoDashboard.styl";

@inject("authStore")
@inject("sarcopeniaMeasureStore")
@observer
@Autobind
class SarcopeniaDemoDashboard extends React.Component {
  /**
   * @method handleContextMenu
   * @description 우 클릭시 발생하는 기본 동작을 막는다.
   * @memberof Viewport
   */
  state = {
    isProfileOpen: false, // 🚀 프로필 팝업 상태 추가
  };

  handleContextMenu = (e) => {
    // 우측 마우스를 눌렀을때, 발생하는 기본 동작을 막는다.
    e.preventDefault();
  };

  handleWrapperClick = (e) => {
    // 우측 마우스를 눌렀을때, 발생하는 기본 동작을 막는다.
    e.stopPropagation();
    if (e.isDefaultPrevented()) {
      return;
    }
  };

  handleDICOMFileDrop(acceptedFiles) {
    const { sarcopeniaMeasureStore } = this.props;
    const { authStore } = this.props;
    authStore.setInfer(false);
    authStore.setMaskInfer(false);
    const firstfile = [acceptedFiles[0]];
    // Do something with the files

    Provider.DICOMFileProvider(firstfile, sarcopeniaMeasureStore);
  }

  toggleProfileMenu() {
    this.setState((prev) => ({ isProfileOpen: !prev.isProfileOpen }));
  }

  closeProfileMenu() {
    this.setState({ isProfileOpen: false });
  }

  async toggleProfile() {
    const token = localStorage.getItem('token');

    if (!token) {
        alert('Please log in to continue.');
        window.location.href = '/login';
        return;
    }

    const { authStore } = this.props;

    try {
        const response = await fetch(`${process.env.REACT_APP_HOMEPAGE_URL}/api/userinfo`, {
            headers: { 'Authorization': `Bearer ${token}` },
            cache: "no-store" // ✅ 캐시 방지 옵션
        });

        if (!response.ok) throw new Error('Failed to fetch user info');

        const userInfo = await response.json();

        // ✅ 항상 최신 데이터를 authStore에 업데이트
        authStore.setUserID(userInfo.email);
        authStore.setCredit(userInfo.credit);

        this.setState({ userID: userInfo.email, credit: userInfo.credit });

        // ✅ 메뉴는 토글 함수로만 관리
        this.toggleProfileMenu();

    } catch (error) {
        console.error('사용자 정보를 불러오는 데 실패했습니다.', error);
        alert('"Failed to load user information.');
    }
}

  render() {
    const { authStore } = this.props;
    // for dev
    // const isSignedIn = true;
    // for product
    const isSignedIn = authStore.getIsSignedIn();
    const credit = authStore.getCredit();
    let userID = authStore.getUserID();

    if (userID === undefined || userID === null || userID === "") {
      userID = "Anonymous";
    }

    return (
      <React.Fragment>
        {isSignedIn === false ? (
          //<Redirect to={{ pathname: "/login" }} />
          <Redirect to={{ pathname: `${Constant.RootPrefix}/login` }} />
        ) : (
          <HotKeys
            keyMap={HotKeyMap.AppGlobalHotKeys.keyMap}
            handlers={HotKeyMap.AppGlobalHotKeys.handlers}
          >
            <Dropzone onDrop={this.handleDICOMFileDrop}>
              {({ getRootProps, getInputProps }) => (
                <div
                  className="wrapper"
                  {...getRootProps({ className: "dropzone" })}
                  onContextMenu={this.handleContextMenu}
                  onClick={this.handleWrapperClick}
                >
                  <input {...getInputProps()} />
                  {/**
                   * 헤더 영역
                   */}
                  <HeaderSection
                    logoImageSrc={BrandImage}
                    logoAlt="i-AID lite"
                    userName={`${userID}`}
                    userIcon={<Icon.SVGUserIcon />}
                    settingIcon={<Icon.SVGSettingIcon onClick={this.toggleProfile} />} // 🚀 클릭 이벤트 추가
                  />
                  {/* 🚀 프로필 팝업 추가 */}
                {this.state.isProfileOpen && (
                <div className="user_menu">
                  <p className="user_menu_name">{userID}</p>
                  <ul className="user_menu_list">
                    <li>
                      <a
                        href={`${process.env.REACT_APP_HOMEPAGE_URL}/profile`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => this.setState({ isProfileOpen: false })}
                      >
                        PROFILE
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${process.env.REACT_APP_HOMEPAGE_URL}/account`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => this.setState({ isProfileOpen: false })}
                      >
                        ACCOUNT
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${process.env.REACT_APP_HOMEPAGE_URL}/charge`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => this.setState({ isProfileOpen: false })}
                      >
                        CHARGE
                      </a>
                    </li>
                  </ul>
                  <div className="user_menu_credit">
                    <p className="credit_icon">i</p>
                    <p className="credit_amount">${credit}</p>
                    <p>Rights</p>
                  </div>
                </div>
              )}

                  {/**
                   * 수평 경계선
                   */}
                  <HorizontalSpliiter />
                  <div className="viewerSection">
                    {/**
                     * 시리즈 리스트
                     */}
                    <div
                      className={classNames(
                        "sidebarMenu",
                        "sidebar-right",
                        "sidebar-open"
                      )}
                    >
                      {/* <div className="controlSection"> */}
                     <ControlSection closeProfileMenu={this.closeProfileMenu} />
                      {/* </div> */}
                      <div className="clearfix"> </div>
                    </div>
                    {/**
                     * 뷰어 영역
                     */}
                    <div className="mainContent">
                      <div className="viewerMain" id="viewerMain">
                        <GridViewportSection />
                      </div>
                    </div>
                  </div>
                  <FooterSection />
                  <DialogSection />
                  <LoadingSnackbar
                    onRequestHide={(notification) => {
                      LoadingSnackbarManager.remove(notification);
                    }}
                  />
                </div>
              )}
            </Dropzone>
          </HotKeys>
        )}
      </React.Fragment>
    );
  }
}

export default SarcopeniaDemoDashboard;
